export const mapOptions: google.maps.MapOptions = {
	disableDefaultUI: false,
	zoomControl: true,
	minZoom: 1,
	styles: [
		{
			featureType: 'landscape',
			elementType: 'labels',
			stylers: [{ visibility: 'on' }],
		},
		{
			featureType: 'poi',
			stylers: [{ visibility: 'on' }],
		},
		{
			featureType: 'road',
			stylers: [{ visibility: 'on' }],
		},
		{
			featureType: 'transit',
			stylers: [{ visibility: 'on' }],
		},
		{
			featureType: 'water',
			stylers: [{ color: '#CDE4E8' }],
		},
	],
};
